import React, { useRef } from 'react'
import className from 'classnames/bind'

import style from './MyhouseMainMasonryContent.module.scss'

const cx = className.bind(style)

type Props = {
  children: React.ReactNode
}

const MyhouseMainMasonryContent: React.FC<Props> = ({ children }: Props) => {
  const divRef = useRef<HTMLDivElement>(null)

  return (
    <div ref={divRef} className={cx('article')}>
      {children}
    </div>
  )
}

export default MyhouseMainMasonryContent
